import { useMemo } from "react";
import { useDatasetDetail } from "./DatasetDetailContext";
import CropGrid from "./CropGrid";

export default function CroppedImages() {
  const { selectedImage } = useDatasetDetail();
  const sourceImages = useMemo(
    () => (selectedImage ? [selectedImage] : []),
    [selectedImage],
  );

  if (!selectedImage) return null;

  return (
    <CropGrid
      sourceImages={sourceImages}
      testIdPrefix="croppedImages"
      context="image"
    />
  );
}
